// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Enums
import {
  RegattaRequirementType,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputCheckbox,
  InputFile,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import {
  regattaRequirementTypeLabel,
} from 'common.language';
import config from '../../../config';

// Components
import InputCreatable from '../../form/InputCreatable';

// Types
type $Props = $Translate & {
  item: $Model<'RegattaRequirement'> | $ModelUpsertParams<'RegattaRequirement'>;
};

type $State = {
  activeRegattaRequirementType: null | RegattaRequirementType;
};

class RegattaRequirementFieldsView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      activeRegattaRequirementType: props.item.Type,
    };
  }

  render() {
    const {
      item,
      t,
    } = this.props;
    const {
      activeRegattaRequirementType,
    } = this.state;

    const fileSource: boolean = activeRegattaRequirementType === RegattaRequirementType.fileSource;
    const selectSource: boolean = _.includes(
      [
        RegattaRequirementType.select,
        // regattaRequirementType.selectUnique,
      ],
      activeRegattaRequirementType,
    );

    return (
      <>
        <Row>
          <Col>
            <AvField
              label={t('Title')}
              name={'Name'}
              required
              value={item.Name}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <AvField
              label={t('Description')}
              name={'Content'}
              required
              type={'textarea'}
              value={item.Content}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <AvField
              label={t('Type')}
              name={'Type'}
              onChange={(e) => {
                const value: null | RegattaRequirementType = _.get(
                  e.target,
                  'value',
                  null,
                );

                this.setState({
                  activeRegattaRequirementType: value,
                });
              }}
              required
              type={'select'}
              value={item.Type}
            >
              {_.map(
                RegattaRequirementType,
                (v, k) => (
                  <option
                    key={k}
                    value={v}
                  >
                    {t(regattaRequirementTypeLabel[v])}
                  </option>
                ),
              )}
            </AvField>
          </Col>
        </Row>
        <Row>
          <Col>
            {fileSource && (
              <InputFile
                accept={['pdf', 'word']}
                fileDirUrl={`${config.CDN_URL}/files`}
                label={t('Example file')}
                labelChangeFile={t('Change file')}
                labelError={t('Error')}
                labelFile={t('File')}
                name={'Source'}
                onError={ErrorLog.exception}
                required
                uploadUrl={`${config.CDN_URL}/v1.0/upload/file`}
                value={item.Source}
              />
            )}
            {selectSource && (
              <InputCreatable
                label={t('Dropdown values')}
                name={'Source'}
                onError={ErrorLog.exception}
                required
                value={item.Source}
              />
            )}
            <InputCheckbox
              label={t('Values is required')}
              name={'Required'}
              value={item.Required}
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default RegattaRequirementFieldsView;
